import { mapActions } from 'vuex';

export default {
  computed: {
    googleUrl () {
      return `${ process.env.VUE_APP_BACKEND_API }/auth/login/google`;
    },

    facebookUrl () {
      return `${ process.env.VUE_APP_BACKEND_API }/auth/login/facebook`;
    }
  },

  methods: {
    ...mapActions([
      'setUser'
    ]),

    handleSocialAuth (url) {
      window.open(url, 'socialAuth')

      const receiveMessage = (event) => {
        if (!event.origin.includes(process.env.VUE_APP_BACKEND_API)) return

        this.setUser(event.data);
        this.$router.push('/wizard');
      }
      
      window.addEventListener('message', receiveMessage, false);
    }
  }
};